import { Shield } from "lucide-react";
import SettingsSection from "./SettingsSection";

export default function SecuritySection({ security, onAction }) {
  const securityOptions = [
    {
      id: "twoFactor",
      label: "Two-Factor Authentication",
      description: "Add an extra layer of security",
      action: security.twoFactorEnabled ? "Disable" : "Enable"
    },
    {
      id: "ipAllowlist",
      label: "IP Allowlist",
      description: "Restrict API access to specific IPs",
      action: "Configure"
    },
    {
      id: "auditLogs",
      label: "Audit Logs",
      description: "View all account activity",
      action: "View Logs"
    }
  ];

  return (
    <SettingsSection
      icon={Shield}
      title="Security"
      description="Security and compliance settings"
    >
      <div className="space-y-4">
        {securityOptions.map((option) => (
          <div
            key={option.id}
            className="flex items-center justify-between py-2"
          >
            <div>
              <p className="text-sm font-medium text-gray-900">
                {option.label}
              </p>
              <p className="text-sm text-gray-500">{option.description}</p>
            </div>
            <button
              onClick={() => onAction(option.id)}
              className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors"
            >
              {option.action}
            </button>
          </div>
        ))}
      </div>
    </SettingsSection>
  );
}
